import React, { useState, useEffect } from 'react';
import './App.css';
import axios from 'axios';
import './RegistrationPage.css'; 

function RegistrationPage() {
  const [registerUsername, setRegisterUsername] = useState('');
  const [registerPassword, setRegisterPassword] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showRegistrationError, setShowRegistrationError] = useState(false);
  const [showPasswordCriteriaError, setShowPasswordCriteriaError] = useState(false);
  const [showUsernameExistsError, setShowUsernameExistsError] = useState(false);

  useEffect(() => {
    const hideMessages = () => {
      setShowSuccessMessage(false);
      setShowErrorMessage(false);
      setShowRegistrationError(false);
      setShowPasswordCriteriaError(false);
      setShowUsernameExistsError(false);
    };

    const messageTimer = setTimeout(hideMessages, 5000);

    return () => {
      clearTimeout(messageTimer);
    };
  }, [showSuccessMessage, showErrorMessage, showRegistrationError, showPasswordCriteriaError, showUsernameExistsError]);

  const isPasswordValid = (password) => {
    if (password.length < 8) {
      return false;
    }

    if (!/[A-Z]/.test(password)) {
        return false;
      }
      
      /* if (!/[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(password)) {
        return false;
      } */
      

    return true;
  };

  const handleRegister = async () => {
    if (!isPasswordValid(registerPassword)) {
      console.log('Senha inválida. A senha deve ter pelo menos 8 caracteres, conter pelo menos um caractere maiúsculo e um caractere especial.');
      setShowPasswordCriteriaError(true);
      return;
    }

    try {
      const response = await axios.post('http://localhost:3000/api/register', {
        username: registerUsername,
        password: registerPassword,
      });

      if (response.status === 201) {
        console.log('Cadastro bem-sucedido:', response.data);
        setShowSuccessMessage(true);
      } else {
        console.log('Erro no cadastro:', response.data);
        if (response.data.error === 'Username already exists') {
          setShowUsernameExistsError(true);
        } else {
          setShowRegistrationError(true);
        }
      }
    } catch (error) {
      console.error('Erro ao cadastrar usuário:', error);
      setShowRegistrationError(true);
    }
  };

  return (
    <div className="registration-page">
      <h1>Cadastro de Usuário</h1>
      <label htmlFor="registerUsername">Nome de Usuário:</label>
      <input
        type="text"
        id="registerUsername"
        value={registerUsername}
        onChange={(e) => setRegisterUsername(e.target.value)}
      />
      <label htmlFor="registerPassword">Senha:</label>
      <input
        type="password"
        id="registerPassword"
        value={registerPassword}
        onChange={(e) => setRegisterPassword(e.target.value)}
      />
      <button className='btnRegistrar' onClick={handleRegister}>Registrar</button>
      {showSuccessMessage && (
        <div className="success-message">Cadastro realizado com sucesso!</div>
      )}
      {showErrorMessage && (
        <div className="error-message">Erro no cadastro. Tente novamente.</div>
      )}
      {showRegistrationError && (
        <div className="error-message">Ops! Algo deu errado. Tente novamente mais tarde.</div>
      )}
      {showPasswordCriteriaError && (
        <div className="error-message">Senha inválida. A senha deve atender aos critérios.</div>
      )}
      {showUsernameExistsError && (
        <div className="error-message">Nome de usuário já existe. Escolha outro nome.</div>
      )}
    </div>
  );
}

export default RegistrationPage;
